import { PickLocation } from '../types';

/**
 * Calculates the total picked quantity from an array of pick locations
 * @param locations - Array of pick locations
 * @returns Total picked quantity from all locations, or 0 if no locations
 */
export const getTotalPickedQuantity = (locations: PickLocation[] | undefined): number => {
  if (!locations || locations.length === 0) {
    return 0;
  }
  return locations.reduce((sum, location) => sum + location.pickedQuantity, 0);
};
